module.exports = __webpack_public_path__ + "img/grid_item.a0cf9853.svg";